export default function ErrorPage() {
  return <div>ERROR 404 PAGE NOT FOUND!</div>;
}
